import FilterRegister from "../../../../components/filter/register-basic";
import reqTipoColaborador from "../../../../services/reqMultiTenant/reqTipoColaborador";
import { RegisterProvider } from "../../register-matrix/context-api";
import MainRegisterMatrix from "../../register-matrix/main";
import Form from "../form";

const MainRegisterCollaboratorType = () => {
	const options = {
		id: "id_tipocolaborador", //usado para saber qual field usar para atualizar
		ident: "collaboratortype", //usado para definir os event listners
		identFilter: "filterCollaborator", //usado para definir os event listners
		title: "Tipo de Colaborador",
		subTitle: "Cadastro",
		tableColumns: [
			{ key: "nome", label: "Tipo de colaborador", align: "left" },
			{ key: "obs", label: "Observação", align: "left" },
			{ key: "empty1", label: "", align: "left" },
			{ key: "empty2", label: "", align: "left" },
			{ key: "actions", label: "", align: "right" },
		],
		hasActive: true,
		parametersFilter: [{ id: 1, label: "Tipo colaborador", value: "nome" }],
	};

	const fetch = async (filterData, newPage) => {
		const { param, paramValue, active } = filterData; //contem active que retorna true ou false

		const response = await reqTipoColaborador.listPaginate(param, paramValue, active, newPage);

		return response;
	};

	const fetchID = async (currentId) => {
		const response = await reqTipoColaborador.listID(currentId);

		return response;
	};

	const insert = async (data) => {
		const response = await reqTipoColaborador.insert(data);

		return response;
	};

	return (
		<RegisterProvider options={options} fetch={fetch} fetchID={fetchID} insert={insert}>
			<MainRegisterMatrix FormComponent={Form} FormFilter={FilterRegister} />
		</RegisterProvider>
	);
};

export default MainRegisterCollaboratorType;
